
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';

const SupportSection = () => {
  const { toast } = useToast();

  const handleContactSupport = () => {
    toast({
      title: "Support Request Sent",
      description: "Our team will contact you shortly.",
    });
  };

  return (
    <div className="text-center">
      <p className="text-gray-500 mb-4">
        Have questions about your results?
      </p>
      <Button 
        variant="outline" 
        className="border-brand-blue text-brand-blue hover:bg-brand-blue hover:text-white"
        onClick={handleContactSupport}
      >
        Contact Support
      </Button>
    </div>
  );
};

export default SupportSection;
